import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { DriverAttributeType } from '../models/credential/driver-attribute-type.model';

@Injectable()
export class AttributeTypeService extends BaseApiService {
    public getAttributeTypeLookup = (): Observable<any> => this.get('Driver/AttributeType/Lookups');

    public getAttributeTypes = (): Observable<{ result: DriverAttributeType[] }> => this.get('Driver/AttributeType');

    public getRequiredEndorsementTypes = (businessTransactionId: number): Observable<any> => this.get(`Driver/AttributeType/Endorsements/Required/${businessTransactionId}`);

    public getDisallowedEndorsementTypes = (businessTransactionId: number): Observable<any> => this.get(`Driver/AttributeType/Endorsements/Disallowed/${businessTransactionId}`);

    public getDisallowedCredentialAttributeTypes = (businessTransactionId: number): Observable<any> => this.get(`Driver/AttributeType/CredentialAttributes/Disallowed/${businessTransactionId}`);
}
